import { z } from 'zod';

export const searchSchema = z.object({
  // Basic fields
  year: z
    .number()
    .optional()
    .refine(value => Number.isInteger(value), 'Năm phải là số nguyên'),
  customerCode: z.string().optional(),
  accountCode: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialValues: SearchFormValues = {
  year: new Date().getFullYear(),
  customerCode: '',
  accountCode: ''
};
